import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree';
import { NotFound } from './NotFound';
import ErrorFallback, { rememberComponentStack } from 'shared/feedback/ErrorFallback';

export const router = createRouter({
  routeTree,
  basepath: '/client',
  defaultNotFoundComponent: NotFound,
  defaultErrorComponent: ErrorFallback,
  defaultOnCatch: (error, errorInfo) => rememberComponentStack(error, errorInfo.componentStack),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
